import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import associateServices from "../../../services";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import InformationToast from "../../../components/toast/InformationToast";
import SlimSelect from "slim-select";

const AffiliateOverview = () => {

    const {user} = useSelector(state => state.authenticationReducer)

    const {t} = useTranslation()
    const [email, setEmail] = useState('')
    const [username, setUsername] = useState('')
    const [countries, setCountries] = useState([])
    const [select, setSelect] = useState(null)

    const [instance, setInstance] = useState({
        code: 45,
        number: ''
    })

    useEffect(() => {
        console.log(select?.getSelected())
    }, [instance?.code])

    const handleChange = (type, value) => {
        setInstance(prevState => ({
            ...prevState,
            [type]: value

        }))
    }

    useEffect(() => {
        setEmail(user?.email || '')
        setUsername(user?.username || '')
        associateServices.getCountryList({}).then(res => setCountries(res?.data || []))
    }, [user?.email])


    useEffect(() => {
        if (countries?.length >= 1 && document.querySelector('#countries')) {
            setSelect(new SlimSelect({
                select: '#countries',
                events: {
                    afterChange: newVal => handleChange('code', newVal[0].value)
                }
            }));
        }
    }, [countries])


    const handleSendOTP = () => associateServices.sendMailToVerify({})
        .then(res => toast.success(t(`api-notifications.${res?.data}`)))


    const handleUpdateUsername = () => {
        associateServices.updateUsername({
            username
        }).then(response => {

            return toast(<InformationToast
                icon={response?.status === 200 ? 'ti-check' : 'ti-error-404'}
                title={response?.status === 200 ? t(`api-notifications.profile-updated`) : '...'}
                message={t(`api-notifications.${response?.data || response?.errors}`)}
            />)
        })
    }
    return (
        <div
            className="tab-pane fade show active"
            id="tab-1"
            role="tabpanel"
            aria-labelledby="1-tab"
            tabIndex={0}
        >

            <div className="row">
                <div className="article col-12">
                    <p className="">
                        {t('affiliate.overview.d1')}
                    </p>

                    <br/>

                    <p className="">
                        {t('affiliate.overview.d2')}
                    </p>
                </div>
            </div>

        </div>


    )

}


export default AffiliateOverview
